export default {
    en: {
        monday: "Mon",
        tuesday: "Tues",
        wednesday: "Wed",
        thursday: "Thus",
        friday: "Fri",
        saturday: "Sat",
        sunday: "Sun",
        sale: "Sale",
        storeExpenses: "Store Expenses",
        expenses: "Product Expenses",
        profit: "Profit",
        january: "January",
        february: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        september: "September",
        october: "October",
        november: "November",
        december: "December",
        short: {
            january: "Jan",
            february: "Feb",
            march: "Mar",
            april: "Apr",
            may: "May",
            june: "Jun",
            july: "Jul",
            august: "Aug",
            september: "Sep",
            october: "Oct",
            november: "Nov",
            december: "Dec",
        }
    },
    uz: {
        monday: "Du",
        tuesday: "Se",
        wednesday: "Chor",
        thursday: "Pay",
        friday: "Juma",
        saturday: "Sha",
        sunday: "Yak",
        sale: "Savdo",
        expenses: "Mahsulot Xarajatlari",
        storeExpenses: "Do'kon Xarajatlari",
        profit: "Foyda",
        january: "Yanvar",
        february: "Febral",
        march: "Mart",
        april: "April",
        may: "May",
        june: "Iyun",
        july: "Iyul",
        august: "Avgust",
        september: "Sentyabr",
        october: "Oktyabr",
        november: "Noyabr",
        december: "Dekabr",
        short: {
            january: "Yan",
            february: "Feb",
            march: "Mar",
            april: "Apr",
            may: "May",
            june: "Iyun",
            july: "Iyul",
            august: "Avg",
            september: "Sen",
            october: "Okt",
            november: "Noy",
            december: "Dek",
        }
    },
    ru: {
        monday: "ПНД",
        tuesday: "ВТР",
        wednesday: "СРД",
        thursday: "ЧТВ",
        friday: "ПТН",
        saturday: "СБТ",
        sunday: "ВСК",
        sale: "Продажа",
        expenses: "Расходы продукта",
        storeExpenses: "Расходы магазина",
        profit: "Прибыль",
        january: "Январь",
        february: "Февраль",
        march: "Март",
        april: "Апрель",
        may: "Май",
        june: "Июнь",
        july: "Июль",
        august: "Август",
        september: "Сентябрь",
        october: "Октябрь",
        november: "Ноябрь",
        december: "Декабрь",
        short: {
            january: "Янв",
            february: "Фев",
            march: "Мар",
            april: "Апр",
            may: "Май",
            june: "Июн",
            july: "Июл",
            august: "Авг",
            september: "Сен",
            october: "Окт",
            november: "Ноя",
            december: "Дек",
        }
    }
}